// @ts-nocheck
/*
  Code from an older interactive, would need some ts and styled-components enhancements.
*/
import { useState } from 'react'
import {
  useTransition,
  animated,
  config as springConfig,
} from '@react-spring/web'
import styled from 'styled-components'
import { Table, TableBody, TableRow, TableCell, TableHead } from '@mui/material'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import TrendIndicator from '../TrendIndicator'

const Panel = ({
  feature,
  data,
  showPanel,
  dataSelection = '',
  dataVersion,
  handleClose,
}: {
  feature: FeaturePolygon | null
  data: any
  showPanel: boolean
  dataSelection: string
  dataVersion: Dictionary
  handleClose: () => void
}) => {
  // if (showPanel) {
  //   document.body.style.overflow = 'hidden'
  // }
  const houseCols = [
    'house_price',
    'house_price_3P',
    'house_price_4P',
    'house_price_5P',
    'house_price_6P',
  ]
  const houseColnames = [
    'Maison',
    '3 pièces',
    '4 pièces',
    '5 pièces',
    '6 pièces',
  ]
  const apptCols = [
    'appt_price',
    'appt_price_1P',
    'appt_price_2P',
    'appt_price_3P',
    'appt_price_4P',
  ]
  const apptColnames = [
    'Appartement',
    '1 pièce',
    '2 pièces',
    '3 pièces',
    '4 pièces',
  ]
  const bothCols = [
    { title: 'Maisons', cols: houseCols, colnames: houseColnames },
    { title: 'Appartements', cols: apptCols, colnames: apptColnames },
  ]

  const transitions = useTransition(showPanel, {
    config: springConfig.stiff,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  if (!feature || !feature.properties) {
    return null
  }

  return transitions((styles, item) => (
    <Container>
      <animated.div
        style={{
          transform: styles.opacity.to(
            (v) => 'translate3d(0,' + (1 - v) * 100 + '%,0)'
          ),
        }}
        className='panel-container'
      >
        <div className='panel'>
          <div className='panel-header'>
            <h4>{feature.properties?.COMMUNE}</h4>
            <div className='cross-container'>
              <div className='cross' onClick={handleClose} />
            </div>
          </div>
          <Info>
            Prix moyens, en euros et au m<sup>2</sup>, au 1<sup>er</sup>{' '}
            {dataVersion.date}:{' '}
          </Info>
          <ul>
            <li>
              maisons, tous nombres de pièces confondus:{' '}
              <b>{data.house_price}</b>{' '}
              {data.house_perc_change && (
                <TrendIndicator
                  perc_change={data.house_perc_change}
                  arrow={data.house_change_category}
                  text={dataVersion.trends ? dataVersion.trends.text : null}
                />
              )}
            </li>
            <li>
              appartements, tous nombres de pièces confondus:{' '}
              <b>{data.appt_price}</b>{' '}
              {data.house_perc_change && (
                <TrendIndicator
                  perc_change={data.appt_perc_change}
                  arrow={data.appt_change_category}
                  text={dataVersion.trends ? dataVersion.trends.text : null}
                />
              )}
            </li>
          </ul>

          {browserCheck.isMobile ? (
            <>
              {bothCols.map((frame) => {
                const columns = frame.cols
                const colnames = frame.colnames
                return (
                  <Table
                    key={frame.title}
                    size='small'
                    sx={{ width: '100%', marginTop: '1rem' }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }} colSpan={2}>
                          {frame.title}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {columns.slice(1).map((col, idx) => (
                        <TableRow key={col}>
                          <TableCell>{colnames.slice(1)[idx]}</TableCell>
                          <TableCell key={col + '_val'}>{data[col]}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )
              })}
            </>
          ) : (
            bothCols.map((frame) => {
              const columns = frame.cols
              const colnames = frame.colnames
              return (
                <Table sx={{ marginTop: '2rem' }} key={frame.title}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }} colSpan={4}>
                        {frame.title}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      {colnames.slice(1).map((col) => (
                        <TableCell key={col} sx={{ fontWeight: 'bold' }}>
                          {col
                            .replace('house', 'maison')
                            .replace('appt_price', 'Appartement ')}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      {columns.slice(1).map((col) => (
                        <TableCell key={col + '_val'}>{data[col]}</TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              )
            })
          )}
        </div>
      </animated.div>
    </Container>
  ))
}
const Info = styled.p`
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  line-height: 1.5;
  font-weight: bold;
`
const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #ffffff;
  z-index: 999;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.085);
  transform: translate3d(0px, 0%, 0px);
  margin-left: auto;
  border-radius: 5px 5px 0 0;

  ul {
    margin-top: 0;
    li {
      line-height: 1.5;
    }
  }

  td,
  th {
    padding: 0.5rem 0;
    color: var(--text-color);
  }

  @media (prefers-color-scheme: dark) {
    color: #eeeeee;
    background: #121212;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .panel {
    max-width: 840px;
    margin: auto;

    padding: calc(1vw + 1em) 1em;
    font-size: 16px;

    .panel-header {
      display: flex;
      flex-direction: row;
      h4 {
        margin: 0;
        // font-family: var(--font-source);
        font-family: var(--font-plex);
        font-size: 1.5em;
      }

      .cross-container {
        cursor: pointer;
        background-color: #5c5573;
        margin-left: auto;
        margin-right: 2em;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (prefers-color-scheme: dark) {
          background-color: transparent;
        }

        .cross {
          position: relative;
          display: inline-block;
          width: 32px;
          height: 32px;
          opacity: 0.75;
          &::before,
          &::after {
            left: 15px;
            position: absolute;
            content: ' ';
            height: 33px;
            width: 2px;
            background-color: #fff;
          }
          &::before {
            transform: rotate(45deg);
          }
          &::after {
            transform: rotate(-45deg);
          }
        }
      }
    }

    a,
    a:visited {
      text-decoration: none;
      background-image: linear-gradient(
        to right,
        rgb(255, 228, 98) 0px,
        rgb(255, 228, 98) 100%
      );
      background-size: 100% 20%;
      background-position-y: 17px;
      background-repeat: repeat-x;
      background-position: bottom;
      color: rgb(32, 35, 70);

      &:hover {
        background-size: 100% 100%;
      }
      @media (prefers-color-scheme: dark) {
        color: #ffffff;
        background-image: linear-gradient(to right, #cccccc 0, #cccccc 100%);
      }
    }
  }
`

export default Panel
